<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M15.71,7.29C15.71,7.29,10.71,2.29,10.71,2.29C10.53,2.11,10.28,2,10,2C10,2,1,2,1,2C0.45,2,0,2.45,0,3C0,3,0,13,0,13C0,13.55,0.45,14,1,14C1,14,10,14,10,14C10.28,14,10.53,13.89,10.71,13.71C10.71,13.71,15.71,8.71,15.71,8.71C15.89,8.530000000000001,16,8.280000000000001,16,8C16,7.72,15.89,7.47,15.71,7.29C15.71,7.29,15.71,7.29,15.71,7.29ZM8.71,9.29C8.89,9.469999999999999,9,9.719999999999999,9,10C9,10.55,8.55,11,8,11C7.72,11,7.47,10.89,7.29,10.71C7.29,10.71,6,9.41,6,9.41C6,9.41,4.71,10.7,4.71,10.7C4.53,10.89,4.28,11,4,11C3.45,11,3,10.55,3,10C3,9.719999999999999,3.11,9.469999999999999,3.29,9.29C3.29,9.29,4.59,8,4.59,8C4.59,8,3.29,6.71,3.29,6.71C3.11,6.53,3,6.28,3,6C3,5.45,3.45,5,4,5C4.28,5,4.53,5.109999999999999,4.71,5.29C4.71,5.29,6,6.59,6,6.59C6,6.59,7.29,5.3,7.29,5.3C7.47,5.109999999999999,7.72,5,8,5C8.55,5,9,5.45,9,6C9,6.28,8.89,6.53,8.71,6.71C8.71,6.71,7.41,8,7.41,8C7.41,8,8.71,9.29,8.71,9.29C8.71,9.29,8.71,9.29,8.71,9.29Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'KeyDelete',
} as DefineComponent
</script>
